<template>
<div class="w-100">
  <v-row align="start" width="100%">
      <NavBar test="Home"></NavBar>
  </v-row>
  <v-container>
    <v-row justify="center" align="center" style="height:80vh">
      <v-col cols="4">
        <v-card @click="goToInventory">
          <v-img src="@/assets/inventory.jpeg" height="200px" width="350px"></v-img>
          <v-card-title class="d-flex justify-center">Inventory</v-card-title>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card @click="goToScheduling">
          <v-img src="@/assets/scheduling.png" height="200px" width="350px"></v-img>
          <v-card-title class="d-flex justify-center" >Scheduling</v-card-title>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card @click="gotoAdmin">
          <v-img src="@/assets/admin.png" height="200px" width="350px"></v-img>
          <v-card-title class="d-flex justify-center" >Admin</v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>
<script>
import NavBar from './NavBar.vue'
export default {
  components: {
    NavBar
  },
  methods: {
    goToInventory() {
        this.$router.push("/inventory/dashboard");
    },
    goToScheduling() {
        this.$router.push("/scheduling/calendar");
    },
    gotoAdmin(){
      this.$router.push("/admin/users");
    }
  }
}
</script>
